import { touchwallPublishAtom } from "./atoms";

export const publishGroups = {
  touchwall: {
    models: ["acknowledgements", "stories", "themes", "links", "media_items"],
    singleItems: [],
    atom: touchwallPublishAtom,
  },
};
